import { FC } from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import s from './qr-editor-modal.module.css';
import { useQrEditor } from './use-qr-editor-modal';
import { QrEditorSettings } from './qr-editor-settings/qr-editor-settings';
import { Button } from '../../../../../../../components/button/button';
import { Loader } from '../../../../../../../components/loader/loader';
import { ModalProps, Modal } from '../../../../../../../components/modal/modal';

export const QrEditorModal: FC<ModalProps> = (props) => {
  const {
    handleSave,
    isLoadingImage,
    isLoadingTemplate,
    template,
    t,
    handleUpdateCrop,
    handleDeleteTemplate,
    setUploadImage,
    uploadImage,
  } = useQrEditor(props);

  return (
    <Modal {...props} className={s.feature} title={t('Редактор шаблона')}>
      {isLoadingTemplate && <Loader />}
      <div className={s.content}>
        <QrEditorSettings setUploadImage={setUploadImage} uploadImage={uploadImage} />
        <div className={s.wrapper}>
          <ReactCrop crop={template?.crop} onChange={(_, c) => handleUpdateCrop(c)} aspect={1}>
            {template?.image && <img src={template?.image} />}
          </ReactCrop>
        </div>
      </div>
      <div className={s.actions}>
        <Button variant="secondary" onClick={props.onClose}>
          {t('Отмена')}
        </Button>
        {template?.id && (
          <Button variant="danger" onClick={handleDeleteTemplate}>
            {t('Удалить')}
          </Button>
        )}
        <Button onClick={handleSave} disabled={isLoadingImage || isLoadingTemplate}>
          {t('Сохранить')}
        </Button>
      </div>
    </Modal>
  );
};
